/* global process */
// Local diagnostics only. No prompt text, persisted game state or extra request.
// Disable with localStorage.setItem('play3Timing', '0').
export const createPlay3Timing = (turnId, { enabled = process.env.NODE_ENV === 'development',
  now = () => performance.now(), report = value => console.info(JSON.stringify(value)),
  frame = action => window.requestAnimationFrame(action) } = {}) => {
  try { if (typeof localStorage !== 'undefined' && localStorage.getItem('play3Timing') === '0') enabled = false; } catch { /* Optional preference. */ }
  const started = now(), milestones = {}, attemptId = enabled ? window.crypto?.randomUUID?.() || `browser-${started}` : null;
  let finished = false, finishing = false;
  const mark = (name, details = {}) => {
    if (!enabled || finished) return;
    const elapsedMs = Math.round(now() - started);
    milestones[name] ??= elapsedMs;
    try { report({ operation: 'play3_browser_timing', turnId, browserAttemptId: attemptId, name, elapsedMs, ...details }); } catch { /* Diagnostic sink. */ }
  };
  mark('submit');
  return { turnId, mark,
    rendered(name) { if (enabled && milestones[name] === undefined) { milestones[name] = null; frame(() => { delete milestones[name]; mark(name); }); } },
    finish(status) {
      if (!enabled || finished || finishing) return;
      finishing = true;
      frame(() => {
        mark('controls_ready', { status });
        try { report({ operation: 'play3_browser_timing', turnId, browserAttemptId: attemptId,
          name: 'summary', totalMs: Math.round(now() - started), status, milestones: { ...milestones } }); } catch { /* Diagnostic sink. */ }
        finished = true;
      });
    },
  };
};
